export const companyHostDeviceModel = {
  type: 'string',
  minLength: 1,
  maxLength: 255,
};
